import { cn } from '@insta-club/utilities';

interface ContainerProps extends React.PropsWithChildren {
    className?: string;
    hasHeader?: boolean;
}

const Container = ({ children, className = '', hasHeader }: ContainerProps) => {
    return <div className={cn('px-5 sm:px-6', { 'pt-14': hasHeader }, className)}>{children}</div>;
};

export default Container;

